module.exports = __webpack_public_path__ + "static/media/loading-spinner.8ee7fcb9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/loading-spinner.gif
// module id = 87
// module chunks = 0